import { ArrowSmRightIcon } from '@heroicons/react/solid'
import { useNavigate } from 'react-router-dom'
import { savedTokens } from 'src/auth'
import {
  ErrorNotLoggedIn,
  Form,
  Paragraph,
  StickyFooter,
  Title,
} from 'src/components'
import EmailHelpBox from 'src/components/Layout/EmailHelpBox'
import {
  savedAccountId,
  savedArn,
  savedConnectUrl,
  savedInstanceArn,
  savedInstanceId,
  savedRegion,
} from '../storage'

import setup from '../../../images/setup.png'
import InputField from 'src/components/Shared/UIComponents/InputField'
import CustomButton from 'src/components/Shared/UIComponents/Button'
import { toast } from 'sonner'

export default function Arn() {
  const navigate = useNavigate()
  const [tokens] = savedTokens.useState(null)
  const [connectUrl, setConnectUrl] = savedConnectUrl.useState('')
  const [arn, setArn] = savedInstanceArn.useState('')

  if (!tokens) {
    return <ErrorNotLoggedIn />
  }

  return (
    <Form
      onSubmit={async (e) => {
        e.preventDefault()

        const arnRegex =
          /^arn:aws:connect:(?<region>\w+(?:-\w+)+):(?<accountId>\d{12}):instance\/(?<instanceId>[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+)$/
        const validRegex = arnRegex.test(arn)
        const matches = arnRegex.exec(arn)

        if (validRegex && matches && matches.groups) {
          savedRegion.set(matches.groups.region)
          savedInstanceId.set(matches.groups.instanceId)
          savedAccountId.set(matches.groups.accountId)
          savedConnectUrl.set(connectUrl)
          savedArn.set(arn)

          navigate('../sso')
        } else {
          toast.error(`ARN is not valid.`)
        }
      }}
    >
      <Title label="ARN" />
      <Paragraph className="col-span-full">
        To complete the setup, we'll need the Access URL and Amazon Resource
        Name (ARN) of your Amazon Connect instance.
      </Paragraph>

      <div className="flex flex-col col-span-full gap-6">
        <InputField
          label="Access URL"
          placeholder="https://INSTANCE-NAME.my.connect.aws"
          title="https://INSTANCE-NAME.my.connect.aws"
          pattern="https:\/\/[\d\w\-]+.my.connect.aws"
          value={connectUrl}
          setValue={(value) => setConnectUrl(value.trim())}
          type="url"
          className="col-span-full"
          tooltip={
            <div className="flex flex-col gap-5">
              <p>
                To find this information, navigate to AWS Console -&gt; Amazon
                Connect -&gt; Select Instance -&gt; Overview.{' '}
              </p>
              <img
                className="w-full object-fit"
                alt="AWS Setup"
                src={setup}
              ></img>
            </div>
          }
        />

        <InputField
          label="Instance ARN"
          placeholder="arn:aws:connect:REGION:ACCOUNT_ID:instance/INSTANCE-ID"
          title="arn:aws:connect:REGION:ACCOUNT_ID:instance/INSTANCE-ID"
          pattern="arn:aws:connect:\w+(?:-\w+)+:\d{12}:instance\/[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+"
          value={arn}
          setValue={(value) => setArn(value.trim())}
          className="col-span-full"
          tooltip={
            <div className="flex flex-col gap-5">
              <p>
                To find this information, navigate to AWS Console -&gt; Amazon
                Connect -&gt; Select Instance -&gt; Overview.{' '}
              </p>
              <img
                className="w-full object-fit"
                alt="AWS Setup"
                src={setup}
              ></img>
            </div>
          }
        />
      </div>
      <StickyFooter>
        <EmailHelpBox className="flex-1" />
        <CustomButton
          type="submit"
          label="next"
          icon={<ArrowSmRightIcon />}
          iconPosition="right"
        />
      </StickyFooter>
    </Form>
  )
}
